







/*!
 * Bloom Multimedia ©
 * https://www.bloom-multimedia.fr/
 *
 * Date: 2022-01-24
 */

declare global {
  interface Window {
    BloomCookies?: {
      link?: string;
      target_link?: string;
      bandeau_text?: string;
      modale_intro?: string;
      order?: any;
      forceInteraction?: boolean;
    };
  }
}

import { Component, Vue } from "vue-property-decorator";
import Bandeau from "@/components/Bandeau.vue";
import Lien from "@/components/Lien.vue";
import Modale from "@/components/Modale.vue";
import Manager from "@/Manager";
const Config = { order: [0, 1, 2, 3], forceInteraction: false };
// window.BloomCookies = {
//   bandeau_text:
//     "Nous utilisons des cookies pour assurer le bon fonctionnement du site, personnaliser le contenu et les publicités, proposer des fonctionnalités relatives aux réseaux sociaux et analyser le trafic. Nous partageons parfois des informations liées à votre navigation avec nos partenaires analytiques, publicitaires et réseaux sociaux. Pour en savoir plus sur les cookies, les données utilisées et les traitements réalisés, ainsi que ceux de nos partenaires, veuillez consulter notre <a href='https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html' target='_blank'>politique de confidentialité</a>.",
//   modale_intro:
//     "Lorsque vous consultez un site Web, des données peuvent être stockées dans votre navigateur ou récupérées à partir de celui-ci, généralement sous la forme de cookies. Ces informations peuvent porter sur vous, sur vos préférences ou sur votre appareil et sont principalement utilisées pour s'assurer que le site Web fonctionne correctement. Les informations ne permettent généralement pas de vous identifier directement, mais peuvent vous permettre de bénéficier d'une expérience Web personnalisée. Parce que nous respectons votre droit à la vie privée, nous vous donnons la possibilité de ne pas autoriser certains types de cookies. Cliquez sur les différentes catégories pour obtenir plus de détails sur chacune d'entre elles, et modifier les paramètres par défaut. Toutefois, si vous bloquez certains types de cookies, votre expérience de navigation et les services que nous sommes en mesure de vous offrir peuvent être impactés. Pour en savoir plus sur les cookies, les données que nous utilisons, les traitements que nous réalisons et les partenaires avec qui nous travaillons, vous pouvez consulter notre <a href='https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html' target='_blank'>politique de confidentialité</a>.",
//   order: [0, 3, 1, 2],
//   forceInteraction: true
// };
Object.assign(Config, window.BloomCookies);

@Component({
  name: "Cookies",
  data() {
    return {
      Config: Config,
    };
  },
  components: {
    Bandeau,
    Lien,
    Modale,
  },
})
export default class Cookies extends Vue {
  mounted() {
    Manager.addAllBtn = document.getElementsByClassName("addAll");
    Manager.deleteAllBtn = document.getElementsByClassName("deleteAll");
    Manager.addBtnAudience = document.getElementById("addBtnAudience");
    Manager.removeBtnAudience = document.getElementById("removeBtnAudience");
    Manager.addBtnPub = document.getElementById("addBtnPub");
    Manager.removeBtnPub = document.getElementById("removeBtnPub");
    Manager.addBtnPerf = document.getElementById("addBtnPerf");
    Manager.removeBtnPerf = document.getElementById("removeBtnPerf");
    Manager.pubEnabled = null;
    Manager.fonctEnabled = null;
    Manager.perfEnabled = null;
    Manager.forceInteraction = Config.forceInteraction;

    Manager.initCookies();

    Manager.showCookiePanel =
      document.getElementsByClassName("showCookiePanel");
    if (Manager.showCookiePanel.length > 0) {
      Object.keys(Manager.showCookiePanel).forEach((key) => {
        Manager.showCookiePanel[Number.parseInt(key)].addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            Manager.initAllBtn();
            Manager.cookiePanel("show");
          }
        );
      });
    }

    Manager.hideCookiePanel = document.querySelector(".closeMe");
    if (
      Manager.hideCookiePanel &&
      Manager.hideCookiePanel !== null &&
      Manager.hideCookiePanel.dataset.dismiss === "cookie"
    ) {
      Manager.hideCookiePanel.addEventListener("click", () => {
        Manager.cookiePanel("hide");
      });
    }

    Manager.validCookiePanel = document.querySelector("#acceptBtn");
    if (Manager.validCookiePanel) {
      Manager.validCookiePanel.setAttribute("disabled", "disabled");
      Manager.validCookiePanel.addEventListener("click", () => {
        if (
          Manager.addBtnAudience &&
          Manager.addBtnAudience.classList.contains("selected")
        ) {
          Manager.pubEnabled = true;
        }

        if (
          Manager.removeBtnAudience &&
          Manager.removeBtnAudience.classList.contains("selected")
        ) {
          Manager.pubEnabled = false;
        }

        if (
          Manager.addBtnPub &&
          Manager.addBtnPub.classList.contains("selected")
        ) {
          Manager.fonctEnabled = true;
        }

        if (
          Manager.removeBtnPub &&
          Manager.removeBtnPub.classList.contains("selected")
        ) {
          Manager.fonctEnabled = false;
        }

        if (
          Manager.addBtnPerf &&
          Manager.addBtnPerf.classList.contains("selected")
        ) {
          Manager.perfEnabled = true;
        }

        if (
          Manager.removeBtnPerf &&
          Manager.removeBtnPerf.classList.contains("selected")
        ) {
          Manager.perfEnabled = false;
        }

        if (!Manager.checkBMCookie()) {
          // Check du CookieBM si il n"existe pas, on le crée
          Manager.createBMCookie();
        }

        Manager.callTagManager(
          "maj-cookie",
          Manager.perfEnabled,
          Manager.fonctEnabled,
          Manager.pubEnabled
        );
        Manager.addCookie("InteractionBandeau");
        Manager.cookiePanel("hide");
        if (Manager.forceInteraction) {
          Manager.hideCookieBackdrop();
        }
      });
    }

    Manager.cancelCookiePanel = document.querySelector("#cancelBtn");
    if (Manager.cancelCookiePanel) {
      Manager.cancelCookiePanel.addEventListener("click", () => {
        Manager.cookiePanel("hide");
      });
    }
  }
}
